import { isValid } from 'date-fns'
import { upperFirst } from 'lodash'
import React from 'react'
import { Element, Heading, Icon } from 'react-bulma-components'
import { formatCompleteDateTime } from '../../utils/date'
import { ArrowRightIcon } from '../icons'
import { HistoryItem, HistoryLocales } from './history'
import { useServiceQuery } from '../../queries/services'

interface HistoryChangeProps {
  change: HistoryItem['changes'][0]
  locales?: HistoryLocales
}

const isIsoDate = (value: string) => {
  if (isNaN(Date.parse(value))) return false
  if (new Date(value).toISOString() === value) return true
  return false
}

const isNumber = (value: string) => {
  if (parseInt(value).toString() === value) return true
  return false
}

const displayChange = (value?: string) => {
  if (value === undefined) return value
  if (value === 'true') return 'Oui'
  if (value === 'false') return 'Non'
  if (isNumber(value)) return value // Before dates parsing ! Numbers are valid date constructors !
  if (isValid(value) || isIsoDate(value)) return upperFirst(formatCompleteDateTime(new Date(value)))
  return value
}

const HistoryChange: React.FC<HistoryChangeProps> = ({ change: _change, locales }) => {

  /* Services are stored as id's
   To avoid deep populate
   Or just storing service names which can deprecate
   We resolve the names dynamically, only if needed
   */
  const change = structuredClone(_change)
  const oldServiceId = change.attribute === 'missionData.service' ? change.oldValue : undefined
  const newServiceId = change.attribute === 'missionData.service' ? change.newValue : undefined
  const oldService = useServiceQuery(oldServiceId)?.data
  const newService = useServiceQuery(newServiceId)?.data

  if (oldService) change.oldValue = oldService.name
  if (newService) change.newValue = newService.name

  const iconParentElement = React.useMemo<'span' | 'div'>(() => {
    if ((change.oldValue?.length || 0) >= 30 || (change.newValue?.length || 0) >= 30) return 'div'
    return 'span'
  }, [change])

  return (
    <Element key={change._id} mt={3} ml={3}>
      <Heading size={6} mb={3}>
        {locales?.changesTitle?.[change.attribute] || change.attribute}
      </Heading>
      <Element style={{ whiteSpace: 'pre-line' }}>
        {change.oldValue && (
          <Element renderAs={iconParentElement}>
            {displayChange(change.oldValue)}{' '}
            {change.newValue && (
              <>
                <Icon style={{ verticalAlign: 'top' }}>
                  <ArrowRightIcon />
                </Icon>{' '}
              </>
            )}
          </Element>
        )}
        {displayChange(change.newValue)}
      </Element>
    </Element>
  )
}

export default HistoryChange
